// ----- create redux store based on NODE_ENV
let storeConfig;

if (process.env.NODE_ENV === 'development') {
  storeConfig = require('./configureStore.dev');
} else {
  storeConfig = require('./configureStore.prod');
}

export default storeConfig;
